exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n* Add your custom code here.\r\n* This file and any changes you make to it are preserved every time the app is generated.\r\n*/\r\n\r\nkendo-grid {\r\n    border-radius: 0 !important; \r\n}\r\n\r\n.fa-calendar-check-o{ \r\n    color: green !important;\r\n}\r\n\r\n.fa-calendar-times-o{ \r\n    color: red !important;\r\n}\r\n\r\n.fa-calendar-plus-o{ \r\n    color: #0c73c9 !important;\r\n}\r\n\r\n.fa-calendar-o, .fa-calendar-minus-o{\r\n    color: #dc9900 !important;\r\n}\r\n\r\n.booking-booking-status i {\r\n    /* margin-right: 8px; */\r\n    font-size: 21px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-tables/djiv-group-service-detail-table/djiv-group-service-detail-table.component.css
// module id = ../../../../../src/app/shared/components/djiv-tables/djiv-group-service-detail-table/djiv-group-service-detail-table.component.css
// module chunks = main